module.exports = {"441581001":"东海街道","441581002":"河西街道","441581003":"城东街道","441581101":"甲子镇","441581102":"碣石镇","441581103":"湖东镇","441581104":"大安镇","441581105":"博美镇","441581106":"内湖镇","441581107":"南塘镇","441581108":"陂洋镇","441581109":"八万镇","441581110":"金厢镇","441581111":"潭西镇","441581112":"甲东镇","441581115":"河东镇","441581116":"上英镇","441581117":"桥冲镇","441581118":"甲西镇","441581119":"西南镇","441581400":"华侨管理区","441581450":"铜锣湖农场","441581451":"星都经济开发试验区","441581452":"大安农场","441581453":"罗经嶂林场","441581454":"湖东林场","441581455":"东海岸林场","441581456":"红岭林场","441581457":"畜牧果林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441581.json
// module id = 2161
// module chunks = 0